export default __webpack_public_path__ + "static/media/img_editions01.e6113a74.png";